import {
    getPageInfo,
    getUserInfo,
} from "@services/tracking/trackers/pageImpressionTracker";
import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import {
    CheckoutToolStepTrackingInfo,
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";
import { OrderDetailsModel } from "@redux/modules/api/data/orderDetail/@types/orderDetails.model";

import { getCartImpressionTrackingInfo } from "@factory/Tracking/cart.model";
import { getOrderDetailsImpressionTrackingInfo } from "@factory/Tracking/order.model";

const trackCheckoutToolStep = (
    eventName: string,
    step: StepVariables,
    context: ToolContext,
    cart: CartModel,
): void => {
    const event: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: {
                ...step,
                ...context,
                cart: getCartImpressionTrackingInfo(cart, ""),
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

const getCustomerName = (orderDetails: OrderDetailsModel) => {
    return (
        orderDetails.customer.firstName + " " + orderDetails.customer.lastName
    );
};

const trackCheckoutToolStepForOrder = (
    eventName: string,
    step: StepVariables,
    context: ToolContext,
    orderDetails: OrderDetailsModel,
): void => {
    const event: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: {
                ...step,
                ...context,
                cart: getOrderDetailsImpressionTrackingInfo(
                    orderDetails,
                    getCustomerName(orderDetails),
                ),
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackCheckoutToolStep, trackCheckoutToolStepForOrder };
